<template>
  <form v-if="form" class="space-y-6 w-full pb-3">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div class="col-span-1">
        <Input v-model="form.name" :errors="errors.name" placeholder="Apakškategorijas nosaukums" />
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      <div class="col-span-1 flex items-center">
        <Checkbox text="Ražošanai" v-model="form.isForProduction" />
      </div>
      <div class="col-span-1 flex items-center">
        <Checkbox text="Servisam" v-model="form.isForService" />
      </div>
        <div class="col-span-1 flex items-center">
            <Checkbox text="Pārdošanai" v-model="form.isForSale" />
        </div>
        <div class="col-span-1 flex items-center">
            <Checkbox text="Inventārām" v-model="form.isForInventory" />
        </div>
        <div class="col-span-1 flex items-center">
            <Checkbox text="Rādīt veikalā" v-model="form.showInWebshop" />
        </div>

    </div>

    <div class="">
      <div class="flex justify-end">
        <button type="button" class="bg-white dark:bg-gray-750 py-2 px-4 border border-gray-300 dark:border-gray-500 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-770 focus:outline-none focus:ring-0 mr-2" @click="close">
          Atcelt
        </button>

        <template v-if="!loading">
          <button type="button" class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-button2-from to-button2-to hover:from-button2-to hover:to-button2-from focus:outline-none focus:border-none transition duration-500 ease-in-out" @click.prevent="submit">
            Pievienot
          </button>
        </template>
        <template v-else>
          <Loading />
        </template>
      </div>
    </div>
  </form>
</template>

<script>
import Input from "@/components/Components/Input";
import Checkbox from "@/components/Components/Checkbox";
import { mapGetters } from "vuex";
import Validation from "@/modules/Validation";
import Loading from "@/components/Components/Loading";

export default {
  name: "AddSubcategory",
  components: {
    Input,
    Checkbox,
    Loading
  },
  props: ["category"],
  data: () => ({
    form: {
      name: '',
      isForProduction: false,
      isForService: false,
      isForSale: false,
      isForInventory: false,
      showInWebshop: false,
    },
  }),
  computed: {
    ...mapGetters({
        loading: "loading",
        errors: "errors",
    }),
    formValidation() {
      return {
        name: {
          rules: ['required']
        },
      }
    }
  },
  methods: {
    close() {
      this.$store.dispatch("removeAllFormsForDisplay");
      this.$emit('close-dialog')
      this.$store.dispatch("setErrors", {});
    },
    submit() {
      this.$Progress.start();

      if (Validation(this.formValidation, this.form)) {
        this.$store.dispatch('createNewCategory', {
          name: this.form.name,
          is_for_production: this.form.isForProduction,
          is_for_service: this.form.isForService,
          is_for_sale: this.form.isForSale,
          is_for_inventory: this.form.isForInventory,
          show_in_webshop: this.form.showInWebshop,
          parent_id: this.category.id
        })
        .then(response => {
          this.$Progress.finish()
          this.close()
          this.$store.dispatch("getSingleCategory", this.$route.params.categoryId)
        })
        .catch(error => {
          this.$Progress.fail()
          this.errors = error.response.data.errors
        })
      } else {
        this.$Progress.fail();
      }
    },
  },
}
</script>